import { getCanTableLoadMore } from 'owa-mail-table-loading-actions';
import loadMoreInTable from '../../actions/table/loadMoreInTable';
import { INITIAL_LOAD_ROW_COUNT } from '../data-loading/TableLoadingConstants';
import { action } from 'satcheljs/lib/legacy';
/**
 * Returns flag indicating whether we should try to load more in the given table on row remove
 * @param tableView where row is removed
 */
function shouldLoadMoreOnRowRemove(tableView) {
    return (tableView.rowKeys.length < INITIAL_LOAD_ROW_COUNT &&
        !tableView.isLoading &&
        getCanTableLoadMore(tableView));
}
/** Try loading more in table when after row removal
 * @param tableView where row is removed
 */
export default action('tryLoadMoreUponRowRemove')(function tryLoadMoreUponRowRemove(tableView) {
    // Try to load more if necessary
    if (shouldLoadMoreOnRowRemove(tableView)) {
        setTimeout(function () {
            // Loading of more rows should be done asynchronously
            // We must check shouldLoadMoreOnRowRemove again after setTimeout
            if (shouldLoadMoreOnRowRemove(tableView)) {
                loadMoreInTable(tableView);
            }
        }, 10);
    }
});
//# sourceMappingURL=tryLoadMoreUponRowRemove.js.map